/* 
 * Export component file to be used on project
*/

import { CheckBox } from './CheckBox'
export default CheckBox
